// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { selectInvoicesTableStyles } from "@eisinc/App/Components/PaymentCenter/SelectInvoicesTable";
import { FormInputWrapper } from "@eisinc/MobiusOverrides/FormField";
import Info from "@eisinc/XDL/Icons/Info";
import { color } from "@eisinc/XDL/Utilities";
import { showAllTabPagination } from "@eisinc/XDL/Utilities/sharedStyles";
import xScreen from "@eisinc/XDL/Utilities/xScreen";
import { css } from "styled-components";

selectInvoicesTableStyles.wrapper = {
    css: css`
        margin-top: 20px;
        width: 100%;
    `,
};

selectInvoicesTableStyles.tableWrapper = {
    css: css`
        max-width: 100%;
        overflow: auto;
    `,
};

selectInvoicesTableStyles.selectedRow = {
    css: css`
        &&&& {
            &.selected td {
                border-bottom: 0;
            }

            &.paid {
                background-color: ${color("success.main", 0.05)};

                .pending {
                    font-weight: 500;
                    color: ${color("success.main")};
                }
            }
        }
    `,
};

selectInvoicesTableStyles.actionsRow = {
    css: css`
        &&&&& {
            &,
            & td,
            &:hover,
            & td:hover {
                cursor: auto;
            }

            td {
                vertical-align: top;
            }

            textarea {
                resize: vertical;
            }

            ${({ highlighted }: any) => {
                if (highlighted) {
                    return css`
                        background-color: ${color("danger.main", 0.2)};
                    `;
                }
            }}
        }
    `,
};

selectInvoicesTableStyles.textField = {
    cssOverrides: {
        formField: css`
            &&&&& {
                input {
                    text-align: right;
                    padding-left: 15px;
                    margin-bottom: 3px;
                }

                ${FormInputWrapper}::before {
                    content: "$";
                    position: absolute;
                    top: 8px;
                    left: 7px;
                }
            }
        `,
    },
};

selectInvoicesTableStyles.tableHeaderWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
    `,
};

selectInvoicesTableStyles.headerLeftWrapper = {
    css: css`
        margin-bottom: 10px;
        margin-top: 3px;
    `,
};

selectInvoicesTableStyles.headerRightWrapper = {
    css: css`
        ${xScreen("lte", "md")} {
            margin-bottom: 10px;
        }
    `,
};

selectInvoicesTableStyles.invoicesCount = {
    size: "20px",
    lineHeight: "24px",
    css: css`
        margin-right: 8px;
    `,
};

selectInvoicesTableStyles.invoicesLabel = {
    size: "20px",
    lineHeight: "24px",
    css: css`
        margin-right: 3px;
    `,
};

selectInvoicesTableStyles.invoicesTotal = {
    size: "20px",
    lineHeight: "24px",
    weight: 600,
};

selectInvoicesTableStyles.pagination = {
    ...showAllTabPagination,
};

selectInvoicesTableStyles.tooltipWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

selectInvoicesTableStyles.tooltip = {
    iconProps: {
        src: Info,
        size: 16,
        color: "primary.main",
        css: css`
            position: relative;
            top: 3px;
            margin-left: 4px;
        `,
    },
    typographyProps: {
        css: css`
            white-space: pre-wrap;
        `,
    },
};
